import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from "react-dom";
import BlackListTermCell from './BlackListTermCell';
import moment from 'moment';

const Table = ({
  allCheckBoxes,
  blackListFields,
  fieldName,
  handleCreate,
  selectAllCheckboxElement,
  setCurrentTab,
  setIsLoading,
  setSelectedBoxes,
  unCheckAllBoxesAndClearState,
  currentTab,
  setTableRefresher,
  selectedBoxes
}) => {

  const dtRef = useRef(null);
  const propsRef = useRef({});
  
  useEffect(() => {
    propsRef.current = { selectedBoxes }; 
  });

  useEffect(() => {
    setIsLoading(true)
    setCurrentTab(fieldName)
    initializeTable();
  }, [])

  useEffect(() => {
    if (setTableRefresher) {
      setTableRefresher(refreshTable);
    }
  }, [setTableRefresher]);

  const refreshTable = (resetPaging = false) => {
    if (dtRef.current) {
        setIsLoading(true); 
        
        dtRef.current.ajax.reload(() => {
            setIsLoading(false);
        }, resetPaging);
    }
  };

  const setColumns = () => {
    return [
      {
        width: '5%',
        data: null,
        defaultContent: '',
        orderable: false
      },
      {
        width: '25%',
        orderData: [3],
        data: 'text',
        defaultContent: '',
      },
      {
        // when displaying, show date in MM-DD-YYYY format, when sorting it will sort by ISO date
        data: 'date_added',
        width: '100px',
        render: (date, type, row) => {
          return (type === 'display') ? date : moment(date, "MMMM-DD-YYYY").toISOString();
        }
      },
      {
        searchable: true,
        visible: false,
        data: 'text'
      },
    ]
  }

  const initializeTable = (userData) => {
    var dt = $("#blacklist-table").DataTable({
      destroy: true,
      columns: setColumns(),
      searching: true,
      ajax: {
        url: '/admin/black_list_terms',
        data: { field: currentTab },
      },
      serverSide: true,
      pageLength: 25,
      start: 0,
      dom: '<"row"<"large-5 columns"f>><"table"t>r<"row bottom"<"large-3 columns"p><"large-3 columns end show-amount"l>>',
      "rowCallback": function(row, data) {
        const termId = data.id;
        
        const currentSelectedBoxes = propsRef.current.selectedBoxes || [];
        const isChecked = currentSelectedBoxes.includes(parseInt(termId)); 
        
        let checkbox = row.children[0].children[0];
        
        const checkedAttr = isChecked ? 'checked' : '';
        row.children[0].innerHTML = `<input class='checkbox-term' id='${termId}' type='checkbox' ${checkedAttr}/>`;
        checkbox = row.children[0].children[0];
        
        if (checkbox) {
            checkbox.removeEventListener('click', handleCheckboxClicked);
            checkbox.addEventListener('click', handleCheckboxClicked);
        }

        let actionCell = row.children[1];
        if (actionCell) {
          const containerId = `action-btn-${data.id}`;
          actionCell.innerHTML = `<div id="${containerId}"></div>`;

          setTimeout(() => {
            const container = document.getElementById(containerId);
            if (container) {
              ReactDOM.render(
                <BlackListTermCell
                term={data}
                fieldName={fieldName}
                blackListFields={blackListFields}
                handleCreate={handleCreate}/>, container);
            }
          }, 0);
        }
      },
      "initComplete": function (settings, json) {
        setIsLoading(false);
      }
    });
    dtRef.current = dt.api();
  }

  const handleCheckboxClicked = (e) => {
    setIdsFromCheckBoxToState()
    if (e.target.checked == false) { selectAllCheckboxElement().checked = false }
  }

  const setIdsFromCheckBoxToState = () => {
    let termIds = []
    allCheckBoxes().forEach( (box) => {
      let id = parseInt(box.id)
      if (box.checked == true) { termIds.push(id) }
    })
    setSelectedBoxes(termIds)
  }

  const toggleAllCheckboxes = () => {
    if (isAllBoxesChecked()) {
      unCheckAllBoxesAndClearState()
    } else {
      handleCheckAllBoxesAndSetState()
    }
  }

  const handleCheckAllBoxesAndSetState = () => {
    selectAllCheckboxElement().checked = true
    checkAllBoxesAndSetState()
  }

  const checkAllBoxesAndSetState = () => {
    const currentPageData = dtRef.current.rows({ page: 'current' }).data().toArray();
    
    let termIds = currentPageData.map(data => data.id);
    
    setSelectedBoxes(termIds);

    refreshTable();
  }

  const isAllBoxesChecked = () => {
    let checked = document.querySelectorAll('.checkbox-term:checked').length
    let totalBoxes = document.querySelectorAll('.checkbox-term').length
    if (checked.length == 0) {return false}
    return checked == totalBoxes
  }

  return (
    <div className="campaigns-index">
      <table id="blacklist-table">
        <thead>
          <tr>
            <th><input id="select-all" type='checkbox' onClick={toggleAllCheckboxes}/></th>
            <th>Term</th>
            <th>Date added</th>
            <th/>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  )
}

export default Table;




